import React from 'react'

import {
  AlignItems,
  BorderStyle,
  Box,
  Color,
  Display,
  DisplayPosition,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

export type TooltipProps = {
  text: string
  onClose: () => void
}

const Tooltip = ({ text, onClose }: TooltipProps) => (
  <Box width="100%">
    <Box
      position={DisplayPosition.Absolute}
      color={Color.ColdGrey_800}
      width="10px"
      top="-13px"
      left="50%"
      style={{
        transform: 'translateX(-50%)',
      }}
    >
      ▲
    </Box>
    <Box
      width="100%"
      minWidth={['250px', '180px']}
      bg={Color.ColdGrey_800}
      paddingV={2}
      paddingH={2}
      borderRadius={1.5}
      borderStyle={BorderStyle.Solid}
      color={Color.White}
      display={Display.Flex}
      alignItems={AlignItems.FlexStart}
    >
      <Text color={Color.White} size={1}>
        {text}
      </Text>
      <Icon
        name="close"
        size={6}
        variant={IconVariant.Inherit}
        onClick={onClose}
        style={{
          cursor: 'pointer',
          paddingLeft: '5px',
        }}
      >
        Close tooltip
      </Icon>
    </Box>
  </Box>
)

export { Tooltip }
